export default __webpack_public_path__ + "static/media/fillet-royal.323011b8.jpg";